export default __webpack_public_path__ + "static/media/embroidery.47577dbe.svg";